import type { ClassRecord, StudentAccount } from "@canvaschool/contracts";

const INACTIVE_MS = 14 * 24 * 60 * 60 * 1000;

/** Enabled students of an ACTIVE class unused for more than 14 days. */
export const inactiveStudents = (
  classRecord: Pick<ClassRecord, "status" | "createdAt">,
  roster: readonly StudentAccount[],
  now: Date,
): StudentAccount[] =>
  classRecord.status !== "ACTIVE"
    ? []
    : roster.filter(
        (student) =>
          student.enabled &&
          now.getTime() -
            Date.parse(student.lastLoginAt ?? classRecord.createdAt) >
            INACTIVE_MS,
      );
